export const FORM_NAMES = {
  login: "login",
  password: "password",
};
